import { LensTwoTone } from '@mui/icons-material';
import { createContext, useState } from 'react';
import API from 'services/api';
import _ from 'lodash';

export const TrademarkContext = createContext({});

let tokenGoogle = localStorage.getItem('google_token');

const TrademarkProvider = props => {
	const [filling, setFilling] = useState([]);
	const [allfilings, setAllFilings] = useState([]);
	const [detailFilling, setDetailFilling] = useState({});
	const [filingByID, setFilingByID] = useState({});
	const [autoGenerate, setAutoGenerate] = useState(false);

	const [selectedTemplate, setSelectedTemplate] = useState(null);

	const [dataFilling, setDataFilling] = useState(null);
	const [listFiling, setListFiling] = useState([]);
	const [tasklists, setTasklists] = useState([]);
	const [groupTask, setGroupTask] = useState([]);
	const [eventlists, setEventLists] = useState([]);

	const [isOpenfsDialog, setOpenfsDialog] = useState(false);
	const [selectedDialog, setSelectedDialog] = useState(null);
	const [selectedFields, setSelectedFields] = useState([]);

	const [manualInvoice, setManualInvoice] = useState([]);
	const [invoiceSelected, setInvoiceSelected] = useState(null);

	const [tasksunwind, setTaskUnwind] = useState([]);
	const [todaytasks, setTodayTasks] = useState([]);
	const [tomorrowtasks, setTomorrowTasks] = useState([]);
	const [thisweektasks, setThisweekTasks] = useState([]);
	const [thismonthtasks, setThismonthtasks] = useState([]);

	const [todayevents, setTodayEvents] = useState([]);
	const [tomorrowevents, setTomorrowEvents] = useState([]);
	const [thisweekevents, setThisweekEvents] = useState([]);
	const [thismonthevents, setMonthEvents] = useState([]);

	const [singleGroups, setSingleGroups] = useState([]);
	const [recordals, setRecordal] = useState([]);
	const [asFilters, setAsfilters] = useState([]);

	const [oaLists, setOALists] = useState([]);
	const [oaEvents, setOAEvents] = useState([]);
	const [oaEventDetail, setOAEventDetail] = useState(null);

	const [filingbypage, setFilingbyPage] = useState([]);
	const [filingError, setFilingError] = useState(false);

	const [withdrawnFile, setwithdrawnFile] = useState(null);
	const [closeFile, setcloseFile] = useState(null);
	const [openWithdrawn, setOpenWithdrawn] = useState(false);
	const [openCloseFile, setOpenCloseFile] = useState(false);

	// Filling
	const getFilling = params => {
		return API.getFilling(params)
			.then(async res => {
				const { data } = res;
				setFilling(data);
				setAllFilings(data);
				return data;
			})
			.catch(err => {});
	};

	const getFilingbyPage = params => {
		return API.getFilingbyPage(params)
			.then(res => {
				const { data } = res;
				setFilingbyPage(data);
			})
			.catch(err => {
				setFilingError(err.message || 'An error occurred');
			});
	};

	// OA
	const getOALists = params => {
		API.getOALists(params)
			.then(res => {
				const { data } = res;
				setOALists(data);
			})
			.catch(err => {
				console.log('err', err);
			});
	};

	const getOAEvenDetail = params => {
		API.getOAEvenDetail(params)
			.then(res => {
				const { data } = res;
				setOAEventDetail(data[0]);
			})
			.catch(err => {
				console.log('err', err);
			});
	};

	const getOAEvents = params => {
		API.getOAEvents(params)
			.then(res => {
				const { data } = res;
				setOAEvents(data);
			})
			.catch(err => {
				console.log('err', err);
			});
	};

	const putStatusEvents = data => {
		return API.putStatusEvents(data)
			.then(res => {
				const { data } = res;

				return data;
			})
			.catch(err => {
				return err;
			});
	};

	const getFilingasFilter = params => {
		return API.getFilingasFilter(params)
			.then(res => {
				const { data } = res;
				setAsfilters(data);

				return data;
			})
			.catch(err => console.log('err', err));
	};

	const getRecordal = params => {
		return API.getRecordal(params)
			.then(res => {
				const { data } = res;
				setRecordal(data);

				return data;
			})
			.catch(err => console.log('err', err));
	};

	const getSingleClass = params => {
		return API.getSingleClass(params)
			.then(res => {
				const { data } = res;
				setSingleGroups(data);

				return data;
			})
			.catch(err => console.log('err', err));
	};

	const getFilingbyID = id => {
		return API.getFilingbyID(id)
			.then(async res => {
				const { data } = res;
				let imgid = data?.trademark?.imgTrademark?.id;
				let dataUri = data?.dataUri;

				let _class =
					data?.class?.length > 0
						? data?.class
						: [{ numberClass: 0, descriptionClass: '' }];
				let newobject = {
					...data,
					class: _class,
				};

				// Fetch image if dataUri is not available and imgid exists
				if (!dataUri && imgid) {
					try {
						let img64 = await API.getFile({ token: tokenGoogle, id: imgid });
						let newDataUri = await img64?.data;
						newobject.dataUri = newDataUri;
					} catch (error) {
						console.log('fetch img err', error);
					}
				}
				setDataFilling(newobject);
				setDetailFilling(newobject);
				setTasklists(data?.tasks || []);
				setManualInvoice(data?.manualInvoice || []);
				setEventLists(data?.events);
				setFilingByID(newobject);

				return data;
			})
			.catch(err => {
				return err;
			});
	};

	const getTaskbyUnwind = async params => {
		await API.getTaskbyUnwind(params)
			.then(res => {
				const { data } = res;
				setTaskUnwind(data);
			})
			.catch(err => console.log('err', err));
	};

	const getTasklistGroup = async params => {
		await API.getTasklistGroup(params)
			.then(res => {
				const { today, tomorrow, thisWeek, thisMonth } = res.data;
				setTodayTasks(today);
				setTomorrowTasks(tomorrow);
				setThisweekTasks(thisWeek);
				setThismonthtasks(thisMonth);
			})
			.catch(err => console.log('err', err));
	};

	const getEventlistGroup = async params => {
		await API.getEventlistGroup(params)
			.then(res => {
				const { today, tomorrow, thisWeek, thisMonth } = res.data;
				setTodayEvents(today);
				setTomorrowEvents(tomorrow);
				setThisweekEvents(thisWeek);
				setMonthEvents(thisMonth);
			})
			.catch(err => console.log('err', err));
	};

	const getDetailFilling = _id => {
		return API.getFilling({ params: { _id } })
			.then(res => {
				const { data } = res;
				setTasklists(data[0]?.tasks);
				setEventLists(data[0]?.events);
				setDetailFilling(data[0]);
				setDataFilling({
					...data[0],
					class:
						data[0]?.class?.length > 0
							? data[0]?.class
							: [{ numberClass: '', descriptionClass: '' }],
				});
				return data[0];
			})
			.catch(err => console.log('err', err));
	};

	const generateNumberReference = data => {
		return API.postGenerateNumberReference(data)
			.then(res => {
				const { data } = res;
				setDataFilling({ ...dataFilling, numberReference: data });
				return data;
			})
			.catch(err => {
				console.log('err', err);
				return '';
			});
	};

	const postFilling = (newdata, signal) => {
		return API.postFilling(newdata, signal)
			.then(res => {
				const { data } = res;
				return data;
			})
			.catch(err => {
				return err;
			});
	};

	const filingGrouping = (newdata, signal) => {
		return API.filingGrouping(newdata, signal)
			.then(res => {
				const { data } = res;
				return data;
			})
			.catch(err => {
				return err;
			});
	};

	const postDataExcel = newdata => {
		return API.postDataExcel(newdata)
			.then(res => {
				const { data } = res;

				return res;
			})
			.catch(err => {
				return err;
			});
	};

	const postDataExcelOPO = newdata => {
		return API.postDataExcelOPO(newdata)
			.then(res => {
				const { data } = res;

				return res;
			})
			.catch(err => {
				return err;
			});
	};

	const postManualMultiClass = newdata => {
		return API.postManualMultiClass(newdata)
			.then(res => {
				const { data } = res;
				console.log('manual', data);
				// setDataFilling(data)
				return data;
			})
			.catch(err => {
				return err;
			});
	};

	const postMulticlass = newdata => {
		return API.postMulticlass(newdata)
			.then(res => {
				const { data } = res;
				setDataFilling(data);
				return data;
			})
			.catch(err => {
				return err;
			});
	};

	const postSingleclass = newdata => {
		return API.postSingleclass(newdata)
			.then(res => {
				const { data } = res;
				let resdata = data.data;

				setListFiling(resdata);
				return resdata[0]?.classCode;
			})
			.catch(err => {
				return err;
			});
	};

	const postGenerateRenewal = newdata => {
		return API.postGenerateRenewal(newdata)
			.then(res => {
				const { data } = res;
				let resdata = data.data;

				setListFiling(resdata);
				return resdata[0]?.classCode;
			})
			.catch(err => {
				return err;
			});
	};

	const postGenerateRecordal = newdata => {
		return API.postGenerateRecordal(newdata)
			.then(res => {
				const { data } = res;
				let resdata = data.data;

				setListFiling(resdata);
				return resdata[0]?.classCode;
			})
			.catch(err => {
				return err;
			});
	};

	const putOAWithRef = (_id, body, signal) => {
		return API.putOAWithRef(_id, body, signal)
			.then(res => {
				const { data } = res;

				return data;
			})
			.catch(err => {
				return err;
			});
	};

	const postRefOA = (newdata, signal) => {
		return API.postRefOA(newdata, signal)
			.then(res => {
				const { data } = res;

				return data;
			})
			.catch(err => {
				return err;
			});
	};

	const postRefOPO = (newdata, signal) => {
		return API.postRefOPO(newdata, signal)
			.then(res => {
				const { data } = res;

				return data;
			})
			.catch(err => {
				return err;
			});
	};

	const putLegalWithRef = (_id, body, signal) => {
		return API.putLegalWithRef(_id, body, signal)
			.then(res => {
				const { data } = res;

				return data;
			})
			.catch(err => {
				return err;
			});
	};

	const postRefLegal = newdata => {
		return API.postRefLegal(newdata)
			.then(res => {
				const { data } = res;

				return data;
			})
			.catch(err => {
				return err;
			});
	};

	const postRefSearch = newdata => {
		return API.postRefSearch(newdata)
			.then(res => {
				const { data } = res;

				return data;
			})
			.catch(err => {
				return err;
			});
	};

	const putFilling = (_id, value, signal) => {
		return API.putFilling(_id, value, signal)
			.then(res => {
				const { data } = res;
				return { status: 200, data: data };
			})
			.catch(err => {
				return { status: 404, data: err?.response?.data?.message };
			});
	};

	const putFillingGenNewRef = (_id, value, signal) => {
		return API.putFillingGenNewRef(_id, value, signal)
			.then(res => {
				const { data } = res;
				return { status: 200, data: data };
			})
			.catch(err => {
				return { status: 404, data: err?.response?.data?.message };
			});
	};

	const putTaskByEvent = (_id, value) => {
		return API.putTaskByEvent(_id, value)
			.then(res => {
				const { data } = res;

				return data;
			})
			.catch(err => {
				return err;
			});
	};

	const deleteFilling = id => {
		return API.deleteFilling(id)
			.then(res => {
				const { data } = res;
				setFilling(filling.filter(item => item._id !== id));
				return { status: 200, data: data };
			})
			.catch(err => {
				console.log('err', err);
				return { status: 404, data: err.message };
			});
	};

	const updateManyFiling = reqbody => {
		return API.updateManyFiling(reqbody)
			.then(res => {
				const { data } = res;
				// setFilling([data, ...filling])
				return { status: 200, data: data };
			})
			.catch(err => {
				return { status: 404, data: err?.response?.data?.message };
			});
	};

	const updateManyFilingForEach = reqbody => {
		return API.updateManyFilingForEach(reqbody)
			.then(res => {
				const { data } = res;
				// setFilling([data, ...filling])
				return { status: 200, data: data };
			})
			.catch(err => {
				return { status: 404, data: err?.response?.data?.message };
			});
	};

	const pushEventToFiling = (_id, value) => {
		return API.pushEventToFiling(_id, value)
			.then(res => {
				const { data } = res;
				getFilingbyID(_id);
				return { status: 200, data: data };
			})
			.catch(err => {
				return { status: 404, data: err?.response?.data?.message };
			});
	};

	return (
		<TrademarkContext.Provider
			value={{
				getFilling,
				getFilingbyID,
				getDetailFilling,
				postFilling,
				postManualMultiClass,
				postMulticlass,
				postSingleclass,
				postGenerateRenewal,
				postGenerateRecordal,

				putFilling,
				putFillingGenNewRef,
				deleteFilling,

				postDataExcel,
				postDataExcelOPO,

				filingGrouping,

				filling,
				filingByID,
				setFilling,
				dataFilling,
				setDataFilling,
				detailFilling,
				setDetailFilling,

				listFiling,
				setListFiling,

				tasklists,
				groupTask,
				setTasklists,

				eventlists,
				setEventLists,

				generateNumberReference,
				allfilings,
				updateManyFiling,
				updateManyFilingForEach,
				pushEventToFiling,
				autoGenerate,
				setAutoGenerate,

				isOpenfsDialog,
				setOpenfsDialog,
				selectedDialog,
				setSelectedDialog,
				selectedFields,
				setSelectedFields,

				tasksunwind,
				getTaskbyUnwind,

				todaytasks,
				tomorrowtasks,
				thisweektasks,
				thismonthtasks,
				getTasklistGroup,

				todayevents,
				tomorrowevents,
				thisweekevents,
				thismonthevents,
				getEventlistGroup,

				singleGroups,
				getSingleClass,

				recordals,
				setRecordal,
				getRecordal,

				asFilters,
				getFilingasFilter,

				oaLists,
				getOALists,
				oaEvents,
				getOAEvents,
				oaEventDetail,
				setOAEventDetail,
				getOAEvenDetail,
				putTaskByEvent,
				putStatusEvents,

				selectedTemplate,
				setSelectedTemplate,

				postRefOA,
				postRefOPO,
				putOAWithRef,

				postRefLegal,
				putLegalWithRef,

				postRefSearch,

				filingbypage,
				filingError,
				getFilingbyPage,

				manualInvoice,
				setManualInvoice,
				invoiceSelected,
				setInvoiceSelected,

				withdrawnFile,
				setwithdrawnFile,
				closeFile,
				setcloseFile,
				openWithdrawn,
				setOpenWithdrawn,
				openCloseFile,
				setOpenCloseFile,
			}}
			{...props}
		/>
	);
};

export default TrademarkProvider;
